var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVerify = function SvgVerify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.938 20.625 7.813 22.5l1.875-1.875M34.063 18.75l-1.876-1.875-1.874 1.875",
    stroke: "#F39237",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 10.082a12.187 12.187 0 0 0-19.688 9.605V22.5M12.5 29.299a12.188 12.188 0 0 0 19.688-9.611v-2.813",
    stroke: "#F39237",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.755 22.93a2.78 2.78 0 0 0 2.323 1.094c1.423 0 2.578-.867 2.578-1.934 0-1.068-1.155-1.933-2.578-1.933-1.424 0-2.578-.866-2.578-1.935 0-1.068 1.155-1.933 2.578-1.933a2.775 2.775 0 0 1 2.322 1.093M20.077 24.024v1.288M20.077 15v1.289",
    stroke: "#F39237",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgVerify;